/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  textErrorSmlouvaFixni: {
    id: "b2b.fixniPozadavkyBox.textErrorSmlouvaFixni",
    defaultMessage:
      "The contract for the selected project does not contain any fixed claims"
  },
  textFixni: {
    id: "b2b.fixniPozadavkyBox.textFixni",
    defaultMessage: "Fixed"
  },
  textObdobi: {
    id: "b2b.fixniPozadavkyBox.textObdobi",
    defaultMessage: "Period of requirements"
  },
  textVsechny: {
    id: "b2b.fixniPozadavkyBox.textVsechny",
    defaultMessage: "Others"
  },
  title: {
    id: "b2b.fixniPozadavkyBox.title",
    defaultMessage: "Phase of requirements"
  },
  titleClose: {
    id: "b2b.fixniPozadavkyBox.titleClose",
    defaultMessage: "Now it is not possible to enter requests"
  },
  titleErrorClosed: {
    id: "b2b.fixniPozadavkyBox.titleErrorClosed",
    defaultMessage: "Now it is not possible to enter requests"
  },
  titleErrorSmlouvaFixni: {
    id: "b2b.fixniPozadavkyBox.titleErrorSmlouvaFixni",
    defaultMessage:
      "Now it is possible to submit requests only for FIXED claims"
  },
  titleOpenFixni: {
    id: "b2b.fixniPozadavkyBox.titleOpenFixni",
    defaultMessage: "Now it is possible to enter requests for FIXED claims"
  },
  titleOpenVsechny: {
    id: "b2b.fixniPozadavkyBox.titleOpenVsechny",
    defaultMessage: "Now it is possible to enter requests"
  }
});

export default () => useMessages(MESSAGES);
